/* Reset Sonner's toast wrapper — visual styling is owned by SnackbarContent */
.wrapper {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 0 !important;
}
